import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import Navbar from './components/Navigation';
import CardGrid from './components/Cards';
import PersonalInfo from './components/PersonalInfo';
import Services from './components/Services';
import Footer from './components/footer';
import WelcomePage from './components/Welcome';
import { AppProvider } from './components/AppContext';
import { useAppContext } from './components/AppContext';
import Contact from './components/Contact';
function App() {


  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;

      const diamonds = document.querySelectorAll('.diamond');
      diamonds.forEach((diamond, index) => {
        const speed = 0.2 + index * 0.05;
        diamond.style.transform = `translateY(${scrollPosition * speed}px) rotate(45deg)`;
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <Router>

      <AppProvider>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-500">
                  <main className="flex-grow">
                    <Navbar />
                    <ConditionalWelcomePage />
                  </main>
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/:username/cards"
            element={
              <>
                <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-500">
                  <main className="flex-grow">
                    <Navbar />
                    <CardGrid />
                  </main>
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <Navbar />
                <PersonalInfo />
                <Footer />
              </>
            }
          />
          <Route
            path="/services"
            element={
              <>
                <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-500">
                  <main className="flex-grow">
                    <Navbar />
                    <Services />
                  </main>
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/contact"
            element={
              <>
                <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-500">
                  <main className="flex-grow">
                    <Navbar />
                    <Contact/>
                    </main>
                </div>
                <Footer />
              </>
            }
          />
        </Routes>
      </AppProvider>

    </Router>
  );
}

const ConditionalWelcomePage = () => {
  const { loggedIn, username } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (loggedIn) {
      navigate(`/${username}/cards`);
    }
    else {
      navigate(`/`);

    }
  }, [loggedIn, navigate, username]);

  return !loggedIn ? <WelcomePage /> : null;
};

export default App;
